import { createFrontAxiosClient } from '@b2ag/axios-client'
import type { AxiosInstance } from '@b2ag/axios-client'
import { pick } from '@b2ag/utils/src/pick'
import { mapFromApi as mapCooperativeFromApi } from '../contexts/cooperative/mappers/cooperative.mapper'
import { mapFromApi as mapProfileFromApi, mapToApi as mapProfileToApi } from '../mappers/profile.mapper'

function formatResponseData({ data }: { data: Record<string, any> }) {
  const { cooperatives = [], profiles = [], current_profile_id: currentProfileId, ...others } = data
  return {
    ...others,
    currentProfileId,
    cooperatives: cooperatives.map(mapCooperativeFromApi),
    profiles: profiles.map(mapProfileFromApi),
  }
}

class UserService {
  api: AxiosInstance

  apiv2: AxiosInstance

  constructor(userApiHost: string) {
    this.api = createFrontAxiosClient(`${userApiHost}/v1/users`)
    this.apiv2 = createFrontAxiosClient(`${userApiHost}/v2/users`)
  }

  get(): Promise<any> {
    return this.api.get('/me').then(formatResponseData)
  }

  createProfile(cooperative: { membershipNumber: string; id: string }): Promise<number> {
    return this.apiv2
      .post('/me/profiles', {
        profile: {
          membershipNumber: cooperative.membershipNumber,
          partnerId: cooperative.id,
        },
      })
      .then(({ data }) => data.id)
  }

  put(data: Record<string, any> | null): Promise<any | null> {
    if (!data) return Promise.resolve(null)
    if (data.profiles && data.profiles.length < 1) {
      return Promise.reject({ detail: 'Vous devez conserver au moins un partenaire' })
    }
    const dataToSend = { ...data }

    if (dataToSend.profiles) {
      dataToSend.profiles = dataToSend.profiles.map(mapProfileToApi)
    }

    if (dataToSend.current_profile) {
      const currentProfile = pick(dataToSend.current_profile, ['id', 'cooperative'])
      dataToSend.current_profile = mapProfileToApi(currentProfile)
    }

    return this.api.put('/me', dataToSend).then(formatResponseData)
  }
}

export default UserService
